export default __webpack_public_path__ + "static/media/img-manage.8d795a96.svg";